import React from "react";
import { Helmet } from "react-helmet";
import SidebarMenu from "../menu/sidebarMenu";
import Header from "../../../components/default/header";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";
import CardCategoryList from "./cardCategoryList";

const CardCategory = () => {
    return (
        <div className="category-wrapper sidebar-menu-enable">
            <Helmet><title>Category</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <SidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <CardCategoryList />
                </div>
            </div>
            
        </div>
    );
}

export default CardCategory;